import { Controller } from "@hotwired/stimulus"

// Live HH:MM:SS countdown to a deadline. At zero the "running" markup gives
// way to the "overdue" one without a reload. Hours are not capped at 24: a
// deadline counted in business hours can sit several days away.
export default class extends Controller {
  static targets = ["clock", "running", "overdue"]
  static values = { deadline: String }

  connect() {
    this.deadline = new Date(this.deadlineValue)
    this.tick()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  tick() {
    const remaining = Math.floor((this.deadline - Date.now()) / 1000)
    if (remaining <= 0) {
      this.expire()
      return
    }
    this.clockTarget.textContent = this.format(remaining)
  }

  expire() {
    clearInterval(this.timer)
    this.runningTarget.hidden = true
    this.overdueTarget.hidden = false
  }

  format(seconds) {
    const parts = [Math.floor(seconds / 3600), Math.floor((seconds % 3600) / 60), seconds % 60]
    return parts.map((part) => String(part).padStart(2, "0")).join(":")
  }
}
